import * as Sentry from '@sentry/vue';
import router from './router';
import Env from '@/env';
import type { App } from 'vue';

const env = new Env();

export const useSentry = (app: App<Element>) => {
    Sentry.init({
        app,
        dsn: env.getSentryDSN(),
        integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
        tracePropagationTargets: [
            'localhost',
            'clientes.aquaservice.com',
            'preclientes.aquaservice.com',
            'devclientes.aquaservice.com',
            'devappclient.aquaservice.com',
            'preappclient.aquaservice.com',
            'appclient.aquaservice.com',
            /^\//,
        ],
        environment: env.getRealEnvName(),
        tracesSampleRate: 1.0,

        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
};
